import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { User } from '../Interfaces/user';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { ApiEndpoints } from 'src/app/services/api.constant';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
  private readonly _http = inject(HttpClient);
  private readonly _router = inject(Router);

  //public
  public currentUser: Observable<User>;

  //private
  private currentUserSubject: BehaviorSubject<User>;

  userData: any;
  /**
   *
   * @param {HttpClient} _http
   * @param {Router} _router
   */
  constructor() {
    this.currentUserSubject = new BehaviorSubject<User>(
      JSON.parse(localStorage.getItem('currentUser')!),
    );
    this.currentUser = this.currentUserSubject.asObservable();
  }

  // getter: currentUserValue
  public get currentUserValue(): User {
    this.currentUserSubject = new BehaviorSubject<User>(
      JSON.parse(localStorage.getItem('currentUser')!),
    );
    this.currentUser = this.currentUserSubject.asObservable();
    return this.currentUserSubject.value;
  }

  /**
   * check if user LoggedIn
   *
   */
  LoggedIn() {
    return !!localStorage.getItem('currentUser');
  }

  public handleUserAuthorization() {
    const currentUser = this.currentUserValue;
    const isLoggedIn = currentUser?.token;

    if (!isLoggedIn) {
      this._router.navigate(['/login']);
    } else {
      this._router.navigate(['/home']);
    }
  }

  /**
   * User logout
   *
   */
  logout() {
    if (this.currentUserValue) {
      const headers = new HttpHeaders().set(
        'Authorization',
        `Bearer ${this.currentUserValue.token}`,
      );
      localStorage.removeItem('User_Data');
      localStorage.removeItem('currentUser');
      this._http
        .get<any>(
          `${environment.mainapiUrl}${ApiEndpoints.Identity.Logout}`,
          // environment.mainapiUrl + ApiEndpoints.Identity.Logout,
          // environment.mainapiUrl + '/Identity/Logout',
          {
            headers: headers,
          },
        )
        .subscribe({
          next: () => {},
          error: () => {
            this._router.navigate(['/login']);
          },
          complete: () => {
            this._router.navigate(['/login']);
          },
        });
    }
  }

  saveUserData(userinfo: User) {
    localStorage.setItem('currentUser', JSON.stringify(userinfo));
  }

  ApiLogin(driverId: number) {
    return this._http.post<any>(
      `${environment.mainapiUrl}${ApiEndpoints.Identity.DriverLogin}`,
      // environment.mainapiUrl + ApiEndpoints.Identity.DriverLogin,
      //environment.mainapiUrl + '/Identity/DriverLogin',
      {
        driverId: driverId,
      },
    );
  }

  CheckEmail(email: string, id?: number) {
    return this._http.get<any>(
      `${environment.mainapiUrl}${
        ApiEndpoints.Identity.CheckIfEmailExist
      }${email}${id ? '?id=${id}' : ''}`,
      //environment.mainapiUrl + `/Identity/CheckIfEmailExist/${email}` +  (id ? `?id=${id}` : ''
    );
  }
}
